<template>
	<div :class="['down',state==1?'loading':'']">
		<div class="bg" :style="{width:percentwidth+'%'}"></div>
		<a @click="handleDown">
			{{text}}
		</a>
	</div>
</template>
<script>

export default {
	props:{
		data:Object,
		name:String
	},
	data(){
		return{
			state:0,
			text:'Download',
			id:'',
			percentwidth:0,
			percent:{}
		}
	},
	created(){
		if(this.name){
			this.text = this.name
		}else{
			this.text = this.$parent.langS[this.$parent.langv].t6
		}
	},
	methods:{
		handleDown(){
    		if(typeof teyes!='undefined'){
    			if(typeof teyes.down!='undefined'){
    				if(this.state==0){
    					this.id = teyes.down(this.data.name, this.data.url);
    					this.getPercent(this.id)
    				}else if(this.state==2){
    					teyes.install(this.id)
    				}else{
    					// teyes.install(this.id)
    				}
    			}else{
    				window.open(this.data.url)
    			}
    		}else{
    			// console.log(this.data.url)
    			window.open(this.data.url)
    		}
    	},
		getPercent(id){
    		if(typeof teyes){
    			clearInterval(this.time)
    			this.time = setInterval(()=>{
    				this.state = 1
    				var percent = (teyes.query(id))
    				percent = eval('(' + percent + ')');
    				this.percent = percent
    				if(percent.total==percent.down){
    					if(!this.name){
    						this.text = 'Install' 
    					}else{
    						this.text  = this.name
    					}
    					this.percent = ''
    					clearInterval(this.time)
    					this.state = 2
    				}else{
    					this.text = (percent.down/percent.total*100).toFixed(2)+'%'
    					
    				}
    				this.percentwidth = (percent.down/percent.total*100).toFixed(2)
    				// this.$forceUpdate();
    			},10)
    		}
    	},
	}
}
	
</script>
<style lang="less">
	.down{
		cursor: pointer;
		font-size: 20px;
		font-weight: bold;
		line-height: 40px;
		padding:.8vw 2vw;
		display: flex;
		background-color:#0f74e7;
		border-radius:40px;
		align-items:center;
		position: relative;
		overflow: hidden;
		&.loading{
			background-color:rgba(15,116,231,0.63);
		}
		.bg{
			content: '';
			display: block;
			position:absolute;
			top: 0;
			right: 0;
			left: 0;
			bottom:0;
			background-color:#0f74e7;
		}
		a{
			min-width: 70px;
			position:relative;
			text-align: center;
			z-index: 1;
		}
		&:before{
			content: '';
			width: 40px;
			height: 40px;
			background-image:url('../assets/down.png');
			background-size:cover;
			display: inline-block;
			margin-right: 10px;
			position:relative;
			z-index: 1;
		}
		&:hover{
			// background-color:#0f74e7bf
		}
	}
</style>